<template lang="pug">
span(v-if="id < 1000")
  .hexagon-mobile.item-mobile-color(:class="isSelected ? 'item-mobile-selected' : ''" @click="clickSelect(index)")
    .item-name {{title}}
span(v-else)
</template>

<script>
export default {
  props: {
    id: Number,
    icon: String,
    title: String,
    isSelected: Boolean,
    index: Number
  },
  methods: {
    clickSelect(index) {
      // console.log('Item Mobile Selected ' + index)
      this.$emit('onListSelect', index)
    }
  }
}
</script>
<style lang="scss">
:root {
  /* Change this to change the appearance of the hexaons */
  --hex-mobile-width: 78px;
  --hex-mobile-between: 5px;
  --hex-mobile-vertical: 6px;
  --font-size-beehive: 12px;

  /* Other hexagon dimentions */
  --hex-mobile-height: calc(var(--hex-mobile-width) / 1.73 /* sqrt(3) */);
  --hex-mobile-margin: calc(var(--hex-mobile-width) / 2);
  --hex-mobile-border: calc(var(--hex-mobile-margin) / 1.73 /* sqrt(3) */);
  --hex-transition: all 0.2s ease;

  /* Colors */
  --color-hex-default: #000000;
  --color-hex-hover: #ffffff;
  --color-beehive: #fbf4d2;
  --color-beehive-selected: #ffd311;
}

/* Hexagons */
.hexagon-container-mobile {
  display: grid;
  grid-template-columns:
    var(--hex-mobile-width) var(--hex-mobile-width) 
    var(--hex-mobile-width) var(--hex-mobile-width);
  grid-auto-rows: calc(var(--hex-mobile-width) - 28.87px / 2);
  grid-gap: var(--hex-mobile-vertical) var(--hex-mobile-between);
  padding-bottom: var(--hex-mobile-border);
  padding-left: 10px;
}
.hexagon-mobile {
  align-items: center;
  background-color: var(--color-hex-default);
  cursor: pointer;
  display: flex;
  fill: white;
  height: var(--hex-mobile-height);
  justify-content: center;
  margin: var(--hex-mobile-border) 0;
  position: relative;
  transition: var(--hex-transition);
  width: var(--hex-mobile-width);
  box-shadow: 2px 0px 5px #00000029;
}

.hexagon-mobile::after,
.hexagon-mobile::before {
  border-left: var(--hex-mobile-margin) solid transparent;
  border-right: var(--hex-mobile-margin) solid transparent;
  content: "";
  left: 0;
  position: absolute;
  transition: var(--hex-transition);
  width: 0;
}
.hexagon-mobile::after {
  border-top: var(--hex-mobile-border) solid var(--color-hex-default);
  top: 100%;
  width: 0;
}
.hexagon-mobile::before {
  border-bottom: var(--hex-mobile-border) solid var(--color-hex-default);
  bottom: 100%;
}

// dịch chuyển sang trái tổ ong
span:nth-child(8n + 5),
span:nth-child(8n + 6),
span:nth-child(8n + 7),
span:nth-child(8n + 8)
{
  margin-left: calc(var(--hex-mobile-width) / 2 + var(--hex-mobile-between) / 2);
}

.hexagon-mobile > .item-name {
  padding: 0 5px;
  text-align: center;
  transition: var(--hex-transition);
  font-size: var(--font-size-beehive);
}

.item-mobile-color {
  background-color: var(--color-beehive);
}
.item-mobile-color::after,
.item-mobile-color::before {
  border-top-color: var(--color-beehive);
  border-bottom-color: var(--color-beehive);
}

.item-mobile-selected {
  background-color: var(--color-beehive-selected);
}
.item-mobile-selected::after,
.item-mobile-selected::before {
  border-top-color: var(--color-beehive-selected);
  border-bottom-color: var(--color-beehive-selected);
}
</style>




// WEBPACK FOOTER //
// itemMobile.vue?8a702f58